import BlogHero, { BlogHeroType } from "./BlogHero";

export { BlogHero, BlogHeroType };

export default BlogHero;
